export enum PermissionScopeEnum {
  ManagementDefault = 'ManagementDefault',
  WebsiteDefault = 'WebsiteDefault',
  InternalDefault = 'InternalDefault',
}
